module.exports = __webpack_public_path__ + "static/nagoya-castle-main-37108a82248772fa093a6501cc648351.jpg";